import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const list = async () => {
  const response = await axios.get(routes.eventsList, AXIOS_DEFAULT_CONFIG);
  return response;
};
export default list;
